import { createSelector } from '@reduxjs/toolkit';

import { createPriceSelector } from '../utils/createPriceSelector.ts';
import { selectFullBathCost } from './selectFullBathCost.ts';
import { selectHalfBathCost } from './selectHalfBathCost.ts';

const calculateBathsCost = (
  halfBathCost: ReturnType<typeof selectHalfBathCost>,
  fullBathCost: ReturnType<typeof selectFullBathCost>,
) => fullBathCost?.add(halfBathCost);

const selectBathsCost = createPriceSelector(
  [selectHalfBathCost, selectFullBathCost],
  calculateBathsCost,
);

export const selectBathsCostDisplay = createSelector([selectBathsCost], (bathsCost) =>
  bathsCost?.toString(true),
);
